import React, { useState, useEffect, useRef } from 'react';
import '../styles/ServicesSection.css';

function ServiceCard({ image, title, isVisible }) {
  return (
    <div className={`service-card ${isVisible ? 'animate-in' : ''}`}>
      <div className="service-icon">
        <img src={image} alt={title} className="service-mascot" />
      </div>
      <h3 className="service-title">{title}</h3>
    </div>
  );
}

function ServicesSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  const services = [
    { image: '/mascot-1.png', title: 'Residential Construction' },
    { image: '/mascot-2.png', title: 'Commercial Building Development' },
    { image: '/mascot-3.png', title: 'Renovation & Remodeling' },
    { image: '/mascot-4.png', title: 'Architectural & Structural Planning' },
    { image: '/mascot-5.png', title: 'Interior & Exterior Design' },
    { image: '/mascot-6.png', title: 'Turnkey Project Execution' },
  ];

  return (
    <section className="services-section" ref={sectionRef}>
      <div className="services-container">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              image={service.image}
              title={service.title}
              isVisible={isVisible}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;